import { Component, OnInit } from '@angular/core';
import { PaymentHistoryComponent } from '../../payment/payment-history/payment-history.component';

@Component({
  selector: 'app-desktop-payment-history',
  templateUrl: './desktop-payment-history.component.html',
  styleUrls: ['./desktop-payment-history.component.scss']
})
export class DesktopPaymentHistoryComponent extends PaymentHistoryComponent implements OnInit {

  ngOnInit(): void {
    this.isLoading = true;
    this.toggleBackService.showBack();
    this.requestHistory(null);
  }

}
